import { NullVisitor } from '@angular/compiler/src/render3/r3_ast';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-processtracking',
  templateUrl: './processtracking.component.html',
  styleUrls: ['./processtracking.component.scss']
})
export class ProcesstrackingComponent implements OnInit {
  @Input("dataCntrl") dataCntrl: any;

  background1 = "var(--sapphire)";
  background2 = "var(--background)";

  activities: any [];
  readmore:boolean = false;

  pageSize: number = 10;
  pageSizeMax: number = 2147483647; // C# Int32.MaxValue
  pageNumber: number = 1;
  Count: number = 0;

  selectedAction: string = "";
  roleUsers: any = [];
  selectedUser: any;

  constructor() { }

  ngOnInit(): void {
    this.activities = [
      {actionid:1, actiontaken:'Submitted', currentassignedyn:false, status:'Assigned', comment:undefined, dateassigned: new Date('2023-05-09 14:03'), datecompleted:new Date('2023-05-11 06:23'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'Send Forward', currentassignedyn:false,status:'Approval Recommended', comment:'Can proceed', dateassigned: new Date('2023-05-09 14:03'), datecompleted:new Date('2023-05-11 06:23'), escalatedyn: true, dateescalated:new Date('2023-05-10 12:01')},
      {actionid:1, actiontaken:'Send Back', currentassignedyn:false,status:'Sent Back - Need Attention', comment:'Must update address', dateassigned: new Date('2023-05-11 18:23'), datecompleted:new Date('2023-05-12 08:19'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'Request More Info', currentassignedyn:false,status:'Awaiting Applicant Feedback', comment:'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate', dateassigned: new Date('2023-05-12 08:19'), datecompleted:new Date('2023-05-12 09:23'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'Send Forward', currentassignedyn:false,status:'Approval Recommended', comment:'All compliant', dateassigned: new Date('2023-05-12 09:23'), datecompleted:new Date('2023-05-12 10:23'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'External Approval', currentassignedyn:false,status:'Approval Recommended', comment:'', dateassigned: new Date('2023-05-12 08:09'), datecompleted:new Date('2023-05-12 08:09'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'Send Forward', currentassignedyn:false,status:'Approval Recommended', comment:'Final Approval', dateassigned: new Date('2023-05-12 08:09'), datecompleted:new Date('2023-05-12 08:09'), escalatedyn: false, dateescalated:undefined},
      {actionid:1, actiontaken:'Approve', currentassignedyn:true,status:'', comment:undefined, dateassigned: new Date('2023-05-12 08:09'), datecompleted:undefined, escalatedyn: false, dateescalated:undefined},

    ]

  }

  viewApp(item){
    console.log(item)
    document.getElementById("secretButton").click();
  }

  onReadMore(){
    this.readmore = !this.readmore;
  }

  getApplications(){
    
  }

  onProceed(){

  }
onCancel(){
  
}
  //#region Paging

  onPage(page) {
    this.pageNumber = page
    this.getApplications();
    return page;
  }

  pageSizeName(value) {
    if (value === this.pageSizeMax) return 'All';
    return value;
  }

  pageSizes() {
    return [5, 10, 25, 50, 100, 500, this.pageSizeMax];
  }

  pageSizeChange() {
    this.getApplications();
  }

  //#endregion

}
